import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { UserContext } from "../../../Context/UserContext";
import Button from "../../../Reusable/Button";
import { TrashIcon } from "@heroicons/react/24/outline";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import MyInput from "../../../Reusable/MyInput";
import * as XLSX from "xlsx"; // xlsx: for exporting excel file. Use xlsx to convert the table data into Excel format and trigger the download.

import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Spinner } from "../../../Reusable/Spinner";
import { BaseURL } from "../../../Reusable/BaseURL";

import { SiMicrosoftexcel } from "react-icons/si";
import { FaFilePdf } from "react-icons/fa6";
import { ImPrinter } from "react-icons/im";
import { FaCopy } from "react-icons/fa6";

import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { TableSkeleton } from "../../../Reusable/skeleton/TableSkeleton";
import { debounce } from "lodash";

export default function ViewQuotationPageForm({
  editBtn,
  // firstPageList,
  links,
  firstPage,
  setGetId,
  spinner,
  totalNo,
  from,
  to,
  editDisable,
  getQuotationFun,
}) {
  const { darkTheme, loginData, setQuotationIndentId, setQuotationPartyId } =
    useContext(UserContext);
  const [searchInp, setSearchInp] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchTotalNo, setSearchTotalNo] = useState(0);
  const [searchFrom, setSearchFrom] = useState(0);
  const [searchTo, setSearchTo] = useState(0);
  const [view, setView] = useState([]);
  const [searchSpinner, setSearchSpinner] = useState(true);

  const navigate = useNavigate();
  useEffect(() => {
    // List()
    // firstPageList();
  }, []);

  // function List(){
  //   fetch("https://erp.vazron.in/api/divisions",{
  //     method: "GET",
  //     headers:{
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`
  //     }
  //   }).then(res=> res.json())
  //   .then(li=> {
  //     if(li?.status){
  //       setView(li.data.data);
  //     }
  //   });
  // }

  // CONFIRM ALERT FOR DELETE A RECORD=================
  function deleteARecord(id) {
    const options = {
      // title: "Are you sure?",
      message: "You want to delete this record?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteConfirm(),
        },
        {
          label: "No",
          // onClick: () => alert('Click No')
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      willUnmount: () => {},
      afterClose: () => {},
      onClickOutside: () => {},
      onKeypress: () => {},
      onKeypressEscape: () => {},
      overlayClassName: "overlay-custom-class-name",
    };
    async function deleteConfirm() {
      await fetch(`${BaseURL}/purchase/quotation/delete/${id}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      })
        .then((resjson) => resjson.json())
        .then((deleteRes) => {
          getQuotationFun();
          toast.success("Deleted!");
        });
    }
    confirmAlert(options);
  }

  function searchList(searchValue) {
    setSearchSpinner(true);
    fetch(`${BaseURL}/hsns?q=${searchValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((search) => {
        setSearchData(search.data.data);
        setSearchTotalNo(search.data.total);
        setSearchFrom(search.data.from);
        setSearchTo(search.data.to);
        setSearchSpinner(false);
      });
  }
  const debouncedFetchResults = useCallback(
    debounce((value) => {
      searchList(value);
    }, 500),
    []
  ); // 500 ms delay

  // COPY TO CLIPBOARD
  const copyToClipboard = () => {
    let data = "S.No.\tHSN no\tHSN %\n";
    if (firstPage.length > 0 && searchInp === "") {
      firstPage.forEach((row, index) => {
        data += `${index + 1}\t${row.hsn_no}\t${row.percent}\n`;
      });
    } else if (searchInp !== "" && searchInp.length > 0) {
      searchData.forEach((row, index) => {
        data += `${index + 1}\t${row.hsn_no}\t${row.percent}\n`;
      });
    }

    navigator.clipboard.writeText(data).then(
      () => {
        toast.success("Table data copied to clipboard");
      },
      (err) => {
        // console.error('Could not copy text: ', err);
        toast.error("Could not copy text");
      }
    );
  };

  // DOWNLOAD EXCEL BTN
  const exportToExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create a worksheet from the table data
    const ws = XLSX.utils.json_to_sheet(firstPage);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "HSN_table_data_excel.xlsx");
  };

  // // PRINT BTN
  // const PrintTable = () => {
  //   const printContents = document.getElementById('tablePrn').outerHTML;
  //   const originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // };

  // PDF/Print BTN-download
  const tableRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  const handleDownloadPdf = async () => {
    const element = tableRef.current;
    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    pdf.addImage(imgData, "PNG", 0, 0);
    pdf.save("HSN_table_pdf.pdf");
  };
  //close - pdf btn download

  return (
    <div>
      {/* TABLE DOWNLOAD BTNs */}
      <div className="mb-2">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <MyInput
              value={searchInp}
              onInput={(e) => {
                setSearchInp(e.target.value);
                debouncedFetchResults(e.target.value);
              }}
              placeholder="Auto Search.."
              type="text"
              className="w-[260px]"
            />
          </div>
          <div className="flex gap-1">
            <Button
              className="py-1 px-[10px]"
              title="Copy"
              onClick={copyToClipboard}
            >
              <FaCopy className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-green-700"
              title="Excel"
              onClick={exportToExcel}
            >
              <SiMicrosoftexcel className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-red-600"
              title="PDF"
              onClick={() => handleDownloadPdf()}
            >
              <FaFilePdf className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-[#6d6e70]"
              title="Print"
              onClick={() => handlePrint()}
            >
              <ImPrinter className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>

      {/* TABLE-RECORDS */}
      <div
        ref={tableRef}
        // className="scrollBar relative overflow-x-auto shadow-md sm:rounded-lg"
        className="scrollBar relative overflow-x-auto overflow-y-auto shadow-md sm:rounded-lg h-auto max-h-[800px]"
      >
        <table
          id="tablePrn"
          className={`w-full text-[11px] uppercase text-left rtl:text-right ${
            darkTheme
              ? "text-gray-500 bg-slate-200"
              : "text-gray-400 bg-slate-100"
          }`}
        >
          <thead
            className={`${
              darkTheme
                ? "bg-gray-700 text-gray-400"
                : "bg-gray-50 text-gray-700"
            }`}
          >
            <tr>
              <th className="px-3 py-3">Action</th>
              <th className="px-3 py-3">Net Amt</th>

              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Grade
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Indent No.
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Indent D
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Party N.
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  P.GST No.
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  Party Mob
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>

              <th scope="col" className="px-3 py-3">
                <div className="flex items-center">
                  S.No.
                  <a href="#">
                    <svg
                      className="w-3 h-3 ms-1.5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                    </svg>
                  </a>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {searchInp !== "" ? (
              searchData.length > 0 ? (
                <>
                  {searchData.map((item, index) => (
                    <tr
                      key={item.id}
                      className={`border-b ${
                        darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                      }`}
                    >
                      <td scope="col" className="px-3 py-3">
                        <div className="flex items-center gap-4">
                          {/* <Button
                          className="!py-0.5 !px-1 !text-[13px]"
                          // onClick={() => openIndentItemModal(item.items)}
                        >
                          View
                        </Button> */}
                          <button
                          // disabled={editDisable}
                          >
                            <FaEdit
                              disabled={editDisable}
                              onClick={() => {
                                editBtn(item.indent.id, item.party.id);
                                setGetId(item.id);
                                navigate("/purchase/update-quotation");
                                setQuotationIndentId(item.indent.id);
                                setQuotationPartyId(item.party.id);
                              }}
                              className={
                                "w-4 h-4 font-medium " +
                                (darkTheme
                                  ? "text-blue-500 hover:text-blue-400"
                                  : "text-[#00334e] hover:text-blue-500")
                              }
                            />
                          </button>

                          <TrashIcon
                            onClick={() => {
                              deleteARecord(item.id);
                            }}
                            className={
                              "w-4 h-4 font-medium " +
                              (darkTheme
                                ? "text-blue-500 hover:text-blue-400"
                                : "text-red-500 hover:text-red-400")
                            }
                          />
                        </div>
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        <span className="text-blue-600">
                          {item.sum_net_amount}
                        </span>
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.grade ? `L-${item.grade}` : ""}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.indent.code}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.indent.date}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.party.name}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.party.gst_no}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {item.party.mobile_no}
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        {index + 1}
                      </td>
                    </tr>
                  ))}
                </>
              ) : searchSpinner ? (
                // <tr
                //   className={`border-b ${
                //     darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                //   }`}
                // >
                //   <th className="px-3 py-1 text-center" colSpan={4}>
                //     <Spinner loading={searchSpinner} />
                //   </th>
                // </tr>
                <TableSkeleton rows={3} columns={9} />
              ) : (
                <tr
                  className={`border-b ${
                    darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                  }`}
                >
                  <th
                    className="px-3 py-1 text-red-500 text-center"
                    colSpan={4}
                  >
                    No record
                  </th>
                </tr>
              )
            ) : firstPage.length > 0 ? (
              firstPage.map((item, index) => (
                <tr
                  key={item.id}
                  className={`border-b ${
                    darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                  }`}
                >
                  <td scope="col" className="px-3 py-3">
                    <div className="flex items-center gap-4">
                      {/* <Button
                        className="!py-0.5 !px-1 !text-[13px]"
                        // onClick={() => openIndentItemModal(item.items)}
                      >
                        View
                      </Button> */}
                      <button
                      // disabled={editDisable}
                      >
                        <FaEdit
                          disabled={editDisable}
                          onClick={() => {
                            editBtn(item.indent.id, item.party.id);
                            setGetId(item.id);
                            navigate("/purchase/update-quotation");
                            setQuotationIndentId(item.indent.id);
                            setQuotationPartyId(item.party.id);
                          }}
                          className={
                            "w-4 h-4 font-medium " +
                            (darkTheme
                              ? "text-blue-500 hover:text-blue-400"
                              : "text-[#00334e] hover:text-blue-500")
                          }
                        />
                      </button>

                      <TrashIcon
                        onClick={() => {
                          deleteARecord(item.id);
                        }}
                        className={
                          "w-4 h-4 font-medium " +
                          (darkTheme
                            ? "text-blue-500 hover:text-blue-400"
                            : "text-red-500 hover:text-red-400")
                        }
                      />
                    </div>
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    <span className="text-blue-600">{item.sum_net_amount}</span>
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.grade ? `L-${item.grade}` : ""}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.indent.code}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.indent.date}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.party.name}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.party.gst_no}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {item.party.mobile_no}
                  </td>
                  <td scope="row" className="px-3 py-2 whitespace-nowrap">
                    {index + 1}
                  </td>
                </tr>
              ))
            ) : spinner ? (
              // <tr
              //   className={`border-b ${
              //     darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
              //   }`}
              // >
              //   <th className="px-3 py-1 text-center" colSpan={4}>
              //     <Spinner loading={spinner} />
              //   </th>
              // </tr>
              <TableSkeleton rows={3} columns={9} />
            ) : (
              <tr
                className={`border-b ${
                  darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                }`}
              >
                <th className="px-3 py-1 text-red-500 text-center" colSpan={4}>
                  No record
                </th>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr
              className={`border-b ${
                darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
              }`}
            >
              <th className="px-3 py-1"></th>
              <th className="px-3 py-1">Net Amt</th>
              <th className="px-3 py-1">Grade</th>
              <th className="px-3 py-1">Indent No.</th>
              <th className="px-3 py-1">Indent D</th>
              <th className="px-3 py-1">Party N.</th>
              <th className="px-3 py-1">P.GST No.</th>
              <th className="px-3 py-1">Party Mob</th>
              <th className="px-3 py-1">S.No.</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
